export default __webpack_public_path__ + "static/char-12-71fd696d0fab973340e866e2cf1ad444.webp";